export default __webpack_public_path__ + "static/media/install-prep.1a6a4f06.jpg";